export default __webpack_public_path__ + "images/pricePledge__0b5471fcc50ec905eabf48b6bab1e822.png";